import { CategoryListing } from './category';
import { FileListing, FileSummary } from './file';
import { SalesOrderListing } from './salesOrder';

export class SalesOrderFile {
  salesOrderId: number;
    fileId: number;
    salesOrderFilePrimary: boolean;
    fileName: string;
    salesOrder: SalesOrderListing;
    file: FileSummary;
    constructor(){
      this.salesOrderId = 0;
      this.fileId = 0;
      this.salesOrderFilePrimary = false;
      this.fileName = '';
      this.salesOrder = null;
      this.file = null;
    }
}
